/**
 * Skeleton do Mural — header padrão + botão de novo aviso + feed de
 * posts da equipe.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Barra de ação (novo aviso) */}
      <div className="flex justify-end">
        <div className="h-10 w-36 rounded-lg bg-slate-200" />
      </div>

      {/* Feed de posts */}
      <div className="flex flex-col gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="rounded-xl border border-slate-200 bg-white p-5">
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 shrink-0 rounded-full bg-slate-200" />
              <div className="h-4 w-48 rounded bg-slate-200" />
            </div>
            <div className="mt-3 h-3 w-full rounded bg-slate-100" />
            <div className="mt-2 h-3 w-2/3 rounded bg-slate-100" />
          </div>
        ))}
      </div>
    </div>
  );
}
